import { Box, BoxComponentProps, Group } from "@mantine/core";
import { ReactNode } from "react";

export const LayoutWorkstationSidebar = ({
  size,
  children,
  sidebar,
  align = "left",
  hideSidebar,
  ...props
}: {
  size?: "xs" | "sm" | "md" | "lg" | "xl" | number;
  children: ReactNode;
  sidebar: ReactNode;
  align?: "left" | "right";
  hideSidebar?: boolean;
} & BoxComponentProps) => {
  const widths = {
    xs: 240,
    sm: 320,
    md: 368,
    lg: 440,
    xl: 576,
  }[size || "md"];

  const width = hideSidebar ? 0 : widths || size;

  const Sidebar = (
    <Box
      w={width}
      h="100%"
      bg="gray.1"
      hidden={hideSidebar}
      style={{
        overflow: "hidden",
        boxShadow: "0 0 4px rgba(0, 0, 0, 0.2)",
        borderRight: "1px solid #ddd",
      }}
    >
      {sidebar}
    </Box>
  );

  return (
    <Group h={"100%"} w={"100%"} gap={0} style={{ overflow: "hidden" }}>
      {align === "left" && Sidebar}
      <Box h="100%" w={`calc(100% - ${width}px)`} bg={"gray.3"} {...props}>
        {children}
      </Box>
      {align === "right" && Sidebar}
    </Group>
  );
};
